module.exports = __webpack_public_path__ + "img/Glow_Wild_Getting_Ready.1ef989f0.jpg";